<template>
  <div class="num-wrap">
    <div @click="jump1()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px;
        "
        src="@/assets/teamGroup/gw_icon.png"
        alt=""
      />
      <div class="name">管网管理</div>
      <div class="number">{{ statisticInfo.pipeGridCount }}</div>
    </div>
    <div @click="jump2()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px;
        "
        src="@/assets/teamGroup/gd_icon.png"
        alt=""
      />
      <div class="name">管道管理</div>
      <div class="number">{{ statisticInfo.pipeLineCount }}</div>
    </div>
    <div @click="jump3()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px;
        "
        src="@/assets/teamGroup/gj_icon.png"
        alt=""
      />
      <div class="name">管井管理</div>
      <div class="number">{{ statisticInfo.pipeWellCount }}</div>
    </div>
    <div @click="jump4()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px;
        "
        src="@/assets/teamGroup/qrcode_icon.png"
        alt=""
      />
      <div class="name">二维码管理（智能井盖）</div>
      <div class="number">{{ statisticInfo.qrCodeCount }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.num-wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 创建2个等宽的列 */
  gap: 10px; /* 可选，设置网格项之间的间隙 */
  align-items: start;
  justify-items: center;
  max-height: 450px;
  padding-top: 50px;
  .grid-item {
    width: 70%;
    height: 150px;
    // display: flex;
    justify-content: center;
    //align-items: center;
    font-size: 25px;
    background-color: #eff6ff;
    cursor: pointer;
    border-radius: 8px;
    .name {
      font-weight: 400;
      font-size: 20px;
      color: #526e9c;
      line-height: 16px;
      height: 16px;
      margin-left: 20px;
      margin-top: 16px;
    }
    .number {
      font-weight: 600;
      font-size: 30px;
      color: #333333;
      line-height: 24px;
      height: 24px;
      margin-left: 25px;
      margin-top: 58px;
    }
  }
}
</style>

<script>
import { statisticInfo } from '@/api/pipenetmanagement';

export default {
  data() {
    return {
      statisticInfo: {
        pipeGridCount: '',
        pipeLineCount: '',
        pipeWellCount: '',
        qrCodeCount: '',
      },
    };
  },
  methods: {
    async getStatisticInfo() {
      const result = await statisticInfo();
      // console.log(">>" + result.data.data);
      if (result.data.code === 200) {
        // console.log(result.data.data);
        this.statisticInfo = result.data.data;
      }
    },
    jump1() {
      this.$router.push('/pipenet');
    },
    jump2() {
      this.$router.push('/drainagepipe');
    },
    jump3() {
      this.$router.push('/well');
    },
    jump4() {
      this.$router.push('/manholecover');
    },
  },
  created() {
    this.getStatisticInfo();
  },
};
</script>
